import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ConfigurationContext } from '../../../shared/context/ConfigurationContext';

import './styles.css';

export default function IconItem(props) {
    const configurationContext = useContext(ConfigurationContext);

    const styleColumns = () => {
        if (configurationContext.data.category.columns === 1)
            return 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12';
        if (configurationContext.data.category.columns === 2)
            return 'col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6';
        if (configurationContext.data.category.columns === 3)
            return 'col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4';
        if (configurationContext.data.category.columns === 4)
            return 'col-6 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3';
        if (configurationContext.data.category.columns === 6)
            return 'col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2 col-xxl-2';
        if (configurationContext.data.category.columns === 12)
            return 'col-12';

        return 'col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2 col-xxl-2';
    };

    return (
        <>
            {
                props.item ?
                    <div key={props.item.id} className={styleColumns()}>
                        <Link to={`/product-category/${props.item.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className='vertical-center horizontal-center' style={{ height: 160, background: '#f8f8f8', borderRadius: 8, padding: 10 }}>
                                <div className='text-center'>
                                    <img src={props.item.imageIcon} style={{ height: 44 }} alt="" />
                                    <div style={{ marginTop: 10 }}>
                                        {props.item.name}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div> : null
            }
        </>
    );
}